import { jsxs as o } from "react/jsx-runtime";
import { LinkWrapper as f } from "./styles58.mjs";
const c = ({
  children: e,
  active: t = !1,
  variant: a = "plain",
  disabled: r = !1,
  icon: i,
  ...n
}) => /* @__PURE__ */ o(
  f,
  {
    ...n,
    $active: t,
    $disabled: r,
    $variant: a,
    onClickCapture: (p) => {
      if (r) {
        p.preventDefault();
        return;
      }
    },
    children: [
      i,
      e
    ]
  }
);
export {
  c as BreadcrumbsLink
};
//# sourceMappingURL=index85.mjs.map
